module.exports = __webpack_public_path__ + "img/boy-gaming.11cd2cfc.gif";